var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOmg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 100,
    viewBox: "0 0 149 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.014 0C137.941 0 148.185 9.26954 148.185 19.1456V39.1471H128.918V19.6348C128.918 17.9274 127.21 16.707 125.014 16.707C122.941 16.707 121.235 17.9274 121.235 19.6348V81.7071C121.235 83.293 122.941 84.6359 125.014 84.6359C127.21 84.6359 128.918 83.293 128.918 81.7071V65.2441H125.014V51.0983H148.794V98.7807H137.088L135.259 95.3668C132.697 97.6839 127.82 100 122.82 100C110.504 100 102.088 91.8283 102.088 80.8533V19.1456C102.088 9.26954 112.21 0 125.014 0ZM61.0878 13.7447L66.7478 48.7549L72.7898 13.7447H95.1383V90.4776H79.7906V41.6573L70.1998 90.4776H60.129L51.4959 41.5605V90.4776H37.6848V13.7447H61.0878ZM15.3672 18.9488C23.9416 18.9488 30.7354 25.9044 30.7354 32.4572V71.767C30.7354 78.3178 23.9416 85.2733 15.3672 85.2733C6.79382 85.2733 0 78.3178 0 71.767V32.4572C0 25.9044 6.79382 18.9488 15.3672 18.9488ZM15.3672 30.0288C13.9934 30.0288 12.8616 30.8383 12.8616 31.9721V72.251C12.8616 73.3849 13.9934 74.1922 15.3672 74.1922C16.743 74.1922 17.8759 73.3849 17.8759 72.251V31.9721C17.8759 30.8383 16.743 30.0288 15.3672 30.0288Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmg);
export default __webpack_public_path__ + "static/media/omg.c3cfc73a.svg";
export { ForwardRef as ReactComponent };